import React from "react";

const Footer = () => {
  return (
    <footer>
      <p>© 2023 Oncidium Inc., a CloudMD Software and Services Inc. company CA. All Rights Reserved</p>
    </footer>
  );
};
export default Footer;
